module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy1"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("© 2023 Emerging Civil War")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("First edition, first printing")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("ISBN-13: 978-1-61121-629-5 (hardcover)")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN-13: 978-1-61121-630-1 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyht"
  }, [_vm._v("Names: Hughes, Dwight Sturtevant, editor. | Mackowski, Chris, editor.")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Title: The Civil War on the water : favorite stories and fresh perspectives from the historians at Emerging Civil War / edited by Dwight Sturtevant Hughes, and Chris Mackowski.")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Other titles: Favorite stories and fresh perspectives from the historians at Emerging Civil War | Emerging Civil War (Website)")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Description: El Dorado Hills, CA : Savas Beatie, [2023] | Series: Emerging Civil War 10th Anniversary Series | Includes index. | Summary: “This work compiles favorite navy tales and obscure narratives by distinguished public historians of the Emerging Civil War in celebration of the organization’s tenth anniversary. This eclectic collection presents new stories and familiar battles from a unique perspective-from the water-sea, surf, and stream”-- Provided by publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Identifiers: LCCN 2022021644 | ISBN 9781611216295 (hardcover) | ISBN 9781611216301 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Subjects: LCSH: United States--History--Civil War, 1861-1865--Naval operations.")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Classification: LCC E591 .C58 2022 | DDC 973.7/5--dc23/eng/20220504")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2022021644",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2022021644")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pub.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Savas Beatie")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("989 Governor Drive, Suite 102")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("El Dorado Hills, CA 95762")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("916-941-6896 / "), _c('a', {
    attrs: {
      "href": "mailto:sales@savasbeatie.com"
    }
  }, [_vm._v("sales@savasbeatie.com")]), _vm._v(" / "), _c('a', {
    attrs: {
      "href": "http://www.savasbeatie.com",
      "target": "_blank"
    }
  }, [_vm._v("www.savasbeatie.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All of our titles are available at special discount rates for bulk purchases in the United States. Contact us for information.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Proudly published, printed, and warehoused in the United States of America.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04983aad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Copyright.vue
// module id = 66
// module chunks = 0